var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/global.js
// module id = ./node_modules/webpack/buildin/global.js
// module chunks = components-2.128.2-f8d7c27521f2f1885aefff864ab2cda9 components-2.128.2-dbb47e2bc351655ad6fbf1e17b65f23e components-2.128.2-c7a8c7394bc66ae923c6b99bcb187418 components-2.128.2-c011781d048ab903660b0648ceb103c0 components-2.128.2-bf91526570dee8d1d2e475eff30670f3 components-2.128.2-a1d4b7fdfc8fc0a7644e311329789d67 components-2.128.2-80d28fd447b9b856400543349a932ae7 components-2.128.2-30ff76cf38997a6935af25d80963059f components-2.128.2-0e200c8656440ab1c1f4f6276a1a6f88 components-2.128.2-0d23622702d6ad67dfdd07d525d4ed3a